import { render, staticRenderFns } from "./create-orgVdc.vue?vue&type=template&id=d44a4ae2&scoped=true"
import script from "./create-orgVdc.vue?vue&type=script&lang=js"
export * from "./create-orgVdc.vue?vue&type=script&lang=js"
import style0 from "./create-orgVdc.vue?vue&type=style&index=0&id=d44a4ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44a4ae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VCol,VContainer,VDivider,VRow,VStepper,VStepperContent,VStepperStep})
